import { ref } from 'vue';
import { black50, black87, primaryViolet, secondaryViolet } from '@/constants/colors';

export const useEditorSideSummary = props => {
  const layerName = ref(props.object.layerName);
  return { black50, black87, primaryViolet, secondaryViolet,layerName };
};
